import "./assets/css/reset.css";
import "./assets/css/fontawesome/all.min.css";
import { createApp } from "vue";
import App from "./App.vue";

createApp(App).mount("#app");
